import type { ShareIconLinkProps } from "@/types/share";

export async function shareAction({ title, text, url }: ShareIconLinkProps) {
  if (navigator.share) {
    try {
      await navigator.share({
        title,
        text,
        url: url || window.location.href,
      });
    } catch (error) {
      console.error("Error sharing:", error);
    }
  } else {
    console.warn("Web Share API not supported on this browser.");
  }
}
